export const SETFASILITAS = "SETFASILITAS";
export const RESETFASILITAS = "RESETFASILITAS";
export const RESETDETAILSFASILITAS = "RESETDETAILSFASILITAS";